'use client';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { domToReact } from 'html-react-parser';
import { isYoutubeEmbed, youtubeEmbedRegex } from '../../dom/index.js';
/**
 * Renders Youtube embeds with lite-youtube-embed
 *
 * @param {import('@headstartwp/core').BlockDef} props The Block props
 *
 * @returns
 */
export function YoutubeLiteBlock({ domNode }) {
    var _a;
    useEffect(() => {
        import('@justinribeiro/lite-youtube');
    }, []);
    if (typeof domNode === 'undefined') {
        return _jsx("span", { children: "There was an error loading the youtube video" });
    }
    const { attribs = {} } = domNode;
    if (typeof (attribs === null || attribs === void 0 ? void 0 : attribs.src) === 'undefined' || typeof (attribs === null || attribs === void 0 ? void 0 : attribs.title) === 'undefined') {
        if (typeof domNode !== 'undefined') {
            return _jsx(_Fragment, { children: domToReact([domNode]) });
        }
    }
    const { src, title, params } = attribs;
    const videoId = (_a = src.match(youtubeEmbedRegex)) === null || _a === void 0 ? void 0 : _a[7];
    if (params) {
        return _jsx("lite-youtube", { videoid: videoId, videotitle: title, params: params });
    }
    return _jsx("lite-youtube", { videoid: videoId, videotitle: title });
}
YoutubeLiteBlock.test = (node) => isYoutubeEmbed(node);
